import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { PageResponse } from '../users/users.service';

export interface NotificationDto {
  notificationId: number;
  title: string;
  content: string;
  roles?: string;
  attachmentFileName?: string;
  isVisible?: string;
  expiryDate?: string;
  startDisplayTime?: string;
  createdBy?: string;
  createdTime?: string;
  modifiedTime?: string;
}

const ADMIN_BASE = `${environment.backend.sso}/v1/admin/notifications`;
const USER_BASE = `${environment.backend.sso}/v1/notifications`;

@Injectable()
export class NotificationsService {
  constructor(private http: HttpClient) {}

  getPage(page: number, size: number, search?: string, isVisible?: string): Observable<PageResponse<NotificationDto>> {
    let params = new HttpParams().set('page', String(page)).set('size', String(size));
    if (search?.trim()) params = params.set('search', search.trim());
    if (isVisible?.trim()) params = params.set('isVisible', isVisible.trim());
    return this.http.get<PageResponse<NotificationDto>>(ADMIN_BASE, { params });
  }

  save(formData: FormData): Observable<any> {
    return this.http.post(ADMIN_BASE, formData);
  }

  delete(id: number): Observable<any> {
    return this.http.delete(`${ADMIN_BASE}/${id}`);
  }

  downloadAttachment(id: number, admin = true): Observable<Blob> {
    const url = admin ? `${ADMIN_BASE}/${id}/attachment` : `${USER_BASE}/${id}/attachment`;
    return this.http.get(url, { responseType: 'blob' });
  }

  getVisibleNotifications(): Observable<any> {
    return this.http.get(USER_BASE);
  }

  getVisiblePage(page: number, size: number, search?: string): Observable<PageResponse<NotificationDto>> {
    let params = new HttpParams().set('page', String(page)).set('size', String(size));
    if (search?.trim()) {
      params = params.set('search', search.trim());
    }
    return this.http.get<PageResponse<NotificationDto>>(USER_BASE, { params });
  }
}
